import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { UnmatchedDevice } from '@app/modules/smart-devices/data/smart-devices.interface';
import { SmartDevicesDialogService } from '@app/modules/smart-devices/dialogs/smart-devices-dialog.service';
import { SmartDevicesService } from '@app/modules/smart-devices/service/smart-devices.service';
import { BehaviorSubject, Subject } from 'rxjs';

@Component({
  standalone: false,
  templateUrl: './device-setup-success.component.html',
  styleUrls: ['./device-setup-success.component.scss'],
})
export class DeviceSetupSuccessComponent implements OnInit {
  phase: 'loading' | 'matching' | 'success' | 'error' = 'loading';

  connectWebviewId: Subject<string> = new Subject();
  unmatchedDevices: BehaviorSubject<UnmatchedDevice[]> = new BehaviorSubject([]);
  error: string | null = null;
  currentDeviceIndex: number = 0;
  deviceCount: number = 0;
  deviceType: 'lock' | 'thermostat' = 'lock';

  constructor(
    private route: ActivatedRoute,
    private smartService: SmartDevicesService,
    private smartDialogService: SmartDevicesDialogService,
    private router: Router,
    private auth: AuthenticationService
  ) {
    this.connectWebviewId.subscribe((connectWebviewId) => {
      this.fetchUnmatchedLocksRelatingToConnectWebviewId(connectWebviewId);
    });

    this.unmatchedDevices.subscribe((unmatchedDevices) => {
      if (unmatchedDevices.length > 0) {
        this.deviceType = unmatchedDevices[0].device_type === 'thermostat' ? 'thermostat' : 'lock';
        this.deviceCount = unmatchedDevices.length;
      }

      if (unmatchedDevices.length === 0) {
        this.handleSuccess();
      } else {
        this.phase = 'matching';
        this.openNextUnmatchedDevice();
      }
    });
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.phase = 'loading';

      const connectWebviewId = params.connect_webview_id as string;

      if (connectWebviewId) {
        this.connectWebviewId.next(connectWebviewId);
      } else {
        this.phase = 'error';
        this.error = 'No connect_webview_id found in query params.';
      }
    });
  }

  fetchUnmatchedLocksRelatingToConnectWebviewId(connectWebviewId: string) {
    this.smartService.getUnmatchedDevices(connectWebviewId).subscribe((unmatchedDevices) => {
      this.unmatchedDevices.next(unmatchedDevices || []);
    });
  }

  openNextUnmatchedDevice() {
    const unmatchedDevice = this.unmatchedDevices.getValue()[this.currentDeviceIndex];

    if (unmatchedDevice) {
      const currentNumber = this.deviceType + ' ' + (this.currentDeviceIndex + 1) + '/' + this.deviceCount;
      this.smartDialogService.openDeviceEditDialog(unmatchedDevice, currentNumber).subscribe(() => {
        this.currentDeviceIndex++;
        this.openNextUnmatchedDevice();
      });
    } else {
      this.handleSuccess();
    }
  }

  handleSuccess() {
    this.phase = 'success';

    if (this.deviceType === 'thermostat') {
      const user = this.auth.getUserDetails();

      this.router.navigate([
        user?.has_thermostats ? '/devices/setup/thermostat-success/done' : '/devices/setup/thermostat-success',
      ]);
    }
  }
}
